import React from 'react';
import { observer } from 'mobx-react-lite';

import Input from '@vromo/ui/components/Input';
import Flex from '@vromo/ui/components/Flex';

interface UrlInputProps {
    url?: string;
    editUrl: (newUrl: string) => void;
}

const UrlInput = observer(function UrlInput({ url, editUrl }: UrlInputProps) {
    return (
        <Flex vertical='middle'
            style={{
                flex: 2,
                marginLeft: '10px',
                maxWidth: '70px',
            }}>
            <Input
                style={{
                    height: 'unset',
                    marginTop: '0px',
                    padding: '10px',
                    textAlign: 'center',
                    width: '400px',
                }}
                value={url}
                type="text"
                onChange={(e: { target: { value: string } }) => editUrl(e.target.value)}
            />
        </Flex>
    );
});

export default UrlInput;
